export const SITE_NAME = "Fanta Royal";
export const TAGLINE = "Conquista la corona";
export const CONTACT_EMAIL = "Ilfantaroyal@gmail.com";
export const SITE_DOMAIN = "ilfantaroyal.it";
export const SITE_URL = process.env.REACT_APP_SITE_URL || window.location.origin;
export const WWW_SITE_URL = process.env.REACT_APP_WWW_SITE_URL || "";
export const REGULATION_PATH = "/regolamento";
export const PRIVACY_PATH = "/privacy-policy";

// 🔒 CONTROLLO ISCRIZIONI
export const REGISTRATIONS_OPEN = false; // Imposta a true per riaprire le iscrizioni
export const REGISTRATIONS_CLOSED_MESSAGE = "Le iscrizioni per questa edizione di Fanta Royal sono chiuse. Grazie a tutti i partecipanti!";

export const HOME_META = {
  title: "Fanta Royal | Fantacalcio premium a premi",
  description:
    "Fanta Royal è il fantacalcio premium dove competizione, strategia e premi esclusivi si incontrano in un torneo fantacalcio online dal tono autorevole.",
  keywords:
    "fantacalcio a premi, fantacalcio online, fantacalcio premium, torneo fantacalcio, Fanta Royal",
};

export const REGULATION_PAGE_INTRO =
  "Regolamento ufficiale di FantaRoyal: competizione di fantacalcio premium basata sul Campionato di Serie A. Di seguito tutti gli articoli che disciplinano iscrizione, modalità di gioco, premi e condotta.";

export const REGULATION_SUMMARY_CARDS = [
  {
    title: "Quota ufficiale",
    text: "70 € per squadra, con accesso alla competizione principale e alle competizioni collaterali previste.",
  },
  {
    title: "Competizione premium",
    text: "Fanta Royal unisce classifica generale, sfide collaterali e premi reali in una struttura competitiva più ambiziosa del solito fantacalcio.",
  },
  {
    title: "Accettazione integrale",
    text: "L’iscrizione e l’acquisto del ticket comportano la presa visione e l’accettazione del regolamento vigente.",
  },
];

export const REGULATION_SECTIONS = [
  {
    title: "Art. 1 – Denominazione della competizione",
    paragraphs: [
      "La manifestazione prende il nome di FantaRoyal ed è organizzata dall'Amministrazione FantaRoyal. La competizione utilizza il Campionato Italiano di Serie A come riferimento sportivo ed è riservata ai partecipanti regolarmente iscritti. L'organizzazione si riserva la facoltà di nominare collaboratori e amministratori incaricati della gestione operativa della lega.",
    ],
  },
  {
    title: "Art. 2 – Finalità",
    paragraphs: [
      "FantaRoyal è un gioco di abilità e strategia. Lo scopo consiste nella costruzione e gestione della migliore rosa possibile durante l'intera stagione, ottenendo il maggior numero di fantapunti. La partecipazione è improntata a: correttezza sportiva, rispetto degli avversari, trasparenza, lealtà e fair play.",
    ],
  },
  {
    title: "Art. 3 – Quota di iscrizione",
    paragraphs: [
      "La quota è fissata in € 70,00. L'iscrizione è valida solo dopo: pagamento, accettazione del presente regolamento, accettazione della Privacy Policy e comunicazione dei dati richiesti.",
    ],
  },
  {
    title: "Art. 4 – Piattaforma di gioco",
    paragraphs: [
      "FantaRoyal utilizzerà una piattaforma ufficiale. L'organizzazione comunicherà modalità di accesso, calendario, scadenze e regolamento tecnico. Le impostazioni della piattaforma prevalgono per tutto quanto non disciplinato dal presente regolamento.",
    ],
  },
  {
    title: "Art. 5 – Requisiti di partecipazione",
    paragraphs: [
      "Possono partecipare gli utenti che abbiano completato l'iscrizione comunicando: Nome, Cognome, e-mail e numero di telefono.",
    ],
  },
  {
    title: "Art. 6 – Struttura generale del format",
    paragraphs: [
      "La competizione comprende le seguenti componenti:",
    ],
    bullets: [
      "Trono Reale: Classifica Generale stagionale",
      "Lega Royale 1vs1: Gironi a scontri diretti",
      "Coppa della Corona: Eliminazione diretta",
      "Coppa d'Apertura: Primi 5 turni",
      "Coppa di Chiusura: Ultimi 5 turni",
    ],
  },
  {
    title: "Art. 7 – Modalità di gioco",
    paragraphs: [
      "Modalità Classic. Una sola rosa valida per tutta la stagione. Classifiche basate sui punteggi della Serie A.",
    ],
  },
  {
    title: "Art. 8 – Composizione della rosa e mercato precampionato",
    paragraphs: [
      "Rosa di 25 calciatori con budget di 250 crediti. Composizione obbligatoria: 3 Portieri, 8 Difensori, 8 Centrocampisti, 6 Attaccanti. Termine ultimo per completare la rosa: inizio della 3ª giornata di Serie A.",
    ],
  },
  {
    title: "Art. 9 – Mercato stagionale",
    paragraphs: [
      "Mercato sempre aperto con un massimo di 25 cambi per l'intera stagione. Una volta esauriti i 25 cambi, non sono possibili ulteriori modifiche alla rosa.",
    ],
  },
  {
    title: "Art. 10 – Formazioni",
    paragraphs: [
      "La formazione va schierata entro il termine stabilito dalla piattaforma. Dopo tale termine, non sono ammesse modifiche o richieste manuali.",
    ],
  },
  {
    title: "Art. 11 – Moduli consentiti",
    paragraphs: [
      "Sono ammessi i seguenti moduli: 3-4-3, 3-5-2, 4-3-3, 4-4-2, 4-5-1, 5-3-2, 5-4-1.",
    ],
  },
  {
    title: "Art. 12 – Impostazioni ufficiali della Lega",
    paragraphs: [
      "Modalità Classic, Mercato aperto, 250 crediti, rosa da 25 calciatori. Modificatore Difesa, Fattore Capitano, Switch e Fattore Fair Play: tutti attivi.",
    ],
  },
  {
    title: "Art. 13 – Trono Reale",
    paragraphs: [
      "Competizione principale basata sulla somma totale dei punti stagionali. Il primo classificato è proclamato 'Re di FantaRoyal'.",
    ],
  },
  {
    title: "Art. 13.1 – Criteri di parità",
    paragraphs: [
      "In caso di parità in classifica: 1) Maggior numero di gol segnati, 2) Miglior punteggio nell'ultima giornata, 3) Miglior posizione nella giornata precedente.",
    ],
  },
  {
    title: "Art. 14 – Premi Trono Reale",
    paragraphs: [
      "I premi sono garantiti al raggiungimento di 200 iscritti. Sotto tale soglia, l'organizzazione può rimodulare i premi mantenendo coerenza con il valore della competizione.",
    ],
    bullets: [
      "1° posto: Honda SH 300",
      "2° posto: Piaggio Liberty 50",
      "3° posto: Crociera MSC",
      "4° posto: Notebook HP 15",
      "5° posto: PlayStation 5 Digital Edition",
      "6° posto: Bici ELOPS Classic 520",
      "7° posto: Xiaomi Electric Scooter 4",
      "8° posto: Calcio balilla Garlando F-1 Goal",
      "9° e 10° posto: 1 Ticket Fanta Royal ciascuno",
    ],
  },
  {
    title: "Art. 15 – Lega Royale 1 vs 1",
    paragraphs: [
      "Suddivisione in gironi con scontri diretti. Premio per il vincitore di ogni girone: 1 Ticket gratuito per l'edizione successiva di FantaRoyal.",
    ],
  },
  {
    title: "Art. 16 – Coppa della Corona",
    paragraphs: [
      "Torneo a eliminazione diretta riservato ai partecipanti della Lega Royale 1 vs 1, basato sul piazzamento nei gironi. Il vincitore riceve un completo calcio della squadra del cuore.",
    ],
  },
  {
    title: "Art. 17 – Coppa d'Apertura",
    paragraphs: [
      "Assegnata al partecipante che totalizza più punti nelle prime 5 giornate di campionato. Premio: 1 notte per 2 persone presso Hotel Castiglione, Ischia.",
    ],
  },
  {
    title: "Art. 18 – Coppa di Chiusura",
    paragraphs: [
      "Assegnata al partecipante che totalizza più punti nelle ultime 5 giornate di campionato. Premio: 1 notte per 2 persone (destinazione da scoprire).",
    ],
  },
  {
    title: "Art. 19 – Formazione",
    paragraphs: [
      "La formazione deve essere inserita entro i termini stabiliti dalla piattaforma. Non sono ammesse modifiche o richieste manuali dopo la scadenza.",
    ],
  },
  {
    title: "Art. 20 – Bonus, Malus e Impostazioni Tecniche",
    paragraphs: [
      "Sistema di punteggio: Gol +3, Assist +1, Rigore parato +3, Portiere imbattuto +1, Ammonizione -0.5, Espulsione -1, Gol subito -1, Autogol -2, Rigore sbagliato -3.",
    ],
  },
  {
    title: "Art. 21 – Modificatore di Difesa",
    paragraphs: [
      "Il Modificatore di Difesa è attivo secondo le impostazioni della piattaforma ufficiale.",
    ],
  },
  {
    title: "Art. 22 – Fattore Capitano",
    paragraphs: [
      "Il Fattore Capitano è attivo: il punteggio del capitano viene moltiplicato secondo le regole della piattaforma.",
    ],
  },
  {
    title: "Art. 23 – Sostituzioni e Switch",
    paragraphs: [
      "Le sostituzioni automatiche (Switch) sono attive in base alle impostazioni della piattaforma ufficiale.",
    ],
  },
  {
    title: "Art. 24 – Fattore Fair Play",
    paragraphs: [
      "Il Fattore Fair Play è attivo secondo le impostazioni della piattaforma ufficiale.",
    ],
  },
  {
    title: "Art. 25 – Reclami",
    paragraphs: [
      "I reclami devono essere presentati entro 48 ore dalla pubblicazione dei risultati. Non si accettano reclami su errori dell'utente o malfunzionamenti tecnici personali.",
    ],
  },
  {
    title: "Art. 26 – Comportamento dei partecipanti",
    paragraphs: [
      "È richiesto un comportamento corretto e rispettoso. Sono vietati: comportamenti offensivi, tentativi di frode, utilizzo di account multipli, violazione delle regole della piattaforma.",
    ],
  },
  {
    title: "Art. 27 – Esclusione dalla competizione",
    paragraphs: [
      "L'organizzazione si riserva il diritto di escludere dalla competizione i partecipanti che violino il regolamento. L'esclusione comporta la perdita immediata di premi e quota di iscrizione, senza diritto a rimborso.",
    ],
  },
  {
    title: "Art. 28 – Premi",
    paragraphs: [
      "I premi saranno consegnati entro 90 giorni dalla conclusione della competizione. L'organizzazione si riserva il diritto di sostituire un premio con altro di valore equivalente.",
    ],
  },
  {
    title: "Art. 29 – Responsabilità",
    paragraphs: [
      "L'organizzazione non è responsabile per: malfunzionamenti della piattaforma esterna, problemi di connettività, errori degli utenti, decisioni arbitrali o voti ufficiali della Serie A.",
    ],
  },
  {
    title: "Art. 30 – Modifiche al regolamento",
    paragraphs: [
      "L'organizzazione si riserva il diritto di modificare il presente regolamento. Le modifiche saranno comunicate tramite i canali ufficiali e si intenderanno accettate con la prosecuzione della partecipazione.",
    ],
  },
  {
    title: "Art. 31 – Privacy",
    paragraphs: [
      "I dati personali forniti saranno trattati in conformità al GDPR (Regolamento UE 2016/679) e alla normativa italiana sulla privacy. Per maggiori informazioni, consultare l'Informativa Privacy del sito.",
    ],
  },
  {
    title: "Art. 32 – Accettazione",
    paragraphs: [
      "L'iscrizione e il pagamento della quota comportano l'accettazione integrale e incondizionata del presente regolamento.",
    ],
  },
  {
    title: "Art. 33 – Clausola finale",
    paragraphs: [
      "Per tutto quanto non espressamente previsto dal presente regolamento, fanno fede le decisioni insindacabili dell'Amministrazione FantaRoyal e le regole tecniche della piattaforma ufficiale scelta per la stagione.",
    ],
  },
];


export const PRIVACY_PAGE_INTRO =
  "Questa Informativa Privacy è una base legale provvisoria, ordinata e facilmente modificabile, predisposta per la messa online di Fanta Royal. I dati del titolare e gli estremi definitivi dovranno essere completati prima della pubblicazione finale in ambiente di produzione.";

export const PRIVACY_SUMMARY_CARDS = [
  {
    title: "Dati raccolti",
    text: "Nome, cognome, email, telefono facoltativo, dati di contatto e informazioni strettamente necessarie alla gestione del ticket e delle richieste.",
  },
  {
    title: "Finalità principali",
    text: "Gestione contatti, acquisto ticket, supporto utenti, sicurezza della piattaforma e adempimenti organizzativi collegati alla competizione.",
  },
  {
    title: "Base modificabile",
    text: "I riferimenti legali e societari sono placeholder e vanno aggiornati con i dati reali del titolare del trattamento.",
  },
];

export const PRIVACY_SECTIONS = [
  {
    title: "Titolare del trattamento",
    paragraphs: [
      "[PLACEHOLDER] Il titolare del trattamento dei dati personali dovrà essere indicato qui con denominazione completa, indirizzo, eventuale P.IVA e contatti ufficiali.",
      `Per il momento, il riferimento operativo di contatto del progetto è ${CONTACT_EMAIL}.`,
    ],
  },
  {
    title: "Dati personali trattati",
    bullets: [
      "Dati anagrafici: nome e cognome.",
      "Dati di contatto: email e telefono facoltativo.",
      "Dati relativi alle richieste inviate dal form contatti.",
      "Dati relativi all’acquisto del ticket e allo stato del pagamento.",
      "Dati tecnici minimi necessari al funzionamento, alla sicurezza e alla tracciabilità operativa del servizio.",
    ],
  },
  {
    title: "Finalità del trattamento",
    bullets: [
      "Gestione delle richieste di informazioni e dei contatti inviati dall’utente.",
      "Gestione dell’acquisto del Ticket Fanta Royal e delle relative verifiche di pagamento.",
      "Invio di comunicazioni operative e aggiornamenti collegati alla competizione.",
      "Tutela della sicurezza, prevenzione abusi e corretta amministrazione del servizio.",
    ],
  },
  {
    title: "Base giuridica",
    paragraphs: [
      "Il trattamento dei dati può basarsi sull’esecuzione di misure precontrattuali o contrattuali richieste dall’utente, sull’adempimento di obblighi organizzativi e sulla legittima esigenza di gestire correttamente la piattaforma e la competizione.",
      "Per attività ulteriori o promozionali non strettamente necessarie, la base giuridica dovrà essere specificata in modo puntuale nella versione definitiva dell’informativa.",
    ],
  },
  {
    title: "Pagamenti e soggetti terzi",
    paragraphs: [
      "Per la gestione del pagamento del ticket, Fanta Royal può avvalersi di fornitori terzi specializzati, come Stripe Checkout, che operano secondo le proprie condizioni e informative privacy.",
      "I dati strettamente necessari alla gestione della transazione vengono trattati al solo scopo di verificare e confermare correttamente il pagamento.",
    ],
  },
  {
    title: "Conservazione dei dati",
    paragraphs: [
      "I dati sono conservati per il tempo strettamente necessario alla gestione del rapporto con l’utente, della competizione e degli adempimenti organizzativi o amministrativi collegati.",
      "Le tempistiche definitive di conservazione andranno completate e dettagliate nella versione finale della privacy policy.",
    ],
  },
  {
    title: "Diritti dell’interessato",
    bullets: [
      "Accesso ai dati personali.",
      "Rettifica o aggiornamento dei dati inesatti.",
      "Cancellazione nei casi previsti dalla normativa applicabile.",
      "Limitazione del trattamento o opposizione quando consentito.",
      "Richiesta di informazioni sui trattamenti effettuati e sui soggetti coinvolti.",
    ],
  },
  {
    title: "Aggiornamenti dell’informativa",
    paragraphs: [
      "La presente informativa può essere aggiornata per riflettere evoluzioni del progetto, cambi normativi o completamento dei dati legali definitivi. Le modifiche rilevanti verranno pubblicate sui canali ufficiali del sito.",
    ],
  },
];
